declare global {
	interface Window {
		fbq: (
			option: string,
			action: string,
			options?: Record<string, unknown>,
		) => void
	}
}

export const pageview = () => {
	if (!window.fbq) {
		console.warn(
			'window.fbq is not defined. This could mean your meta pixel script has not loaded on the page yet.',
		)
		return
	}
	window.fbq('track', 'PageView')
}

export const event = ({
	action,
	category,
	label,
	value,
	...rest
}: Record<string, any>) => {
	if (!window.fbq) {
		console.warn(
			'window.fbq is not defined. This could mean your meta pixel script has not loaded on the page yet.',
		)
		return
	}
	window.fbq('track', action, rest)
}
